import { BasePageTrackingService } from '../BasePageTrackingService';

export class BankAccountTrackingService extends BasePageTrackingService {}
